/* Live Turn-In box: subject rows with today's assignment. Glass + 3D shadow
 * come from the shared .glass .glass--solid utilities; this module handles
 * layout + typography only. */

.box {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: clamp(16px, 1.6vw, 28px) clamp(18px, 1.8vw, 32px);
  gap: clamp(10px, 1vh, 18px);
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
}

.title {
  margin: 0;
  flex: 0 0 auto;
  font-family: var(--token-font-display);
  font-size: clamp(28px, 2.6vw, 48px);
  letter-spacing: 0.5px;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 0.7vh, 12px);
}

/* Subject | assignment, two columns with a hairline between rows. */
.row {
  display: grid;
  grid-template-columns: clamp(120px, 30%, 220px) 1fr;
  align-items: baseline;
  gap: clamp(10px, 1vw, 20px);
  padding: clamp(8px, 0.9vh, 14px) clamp(8px, 0.8vw, 14px);
  border-bottom: 1px solid color-mix(in srgb, var(--token-accent) 28%, transparent);
}

.subject {
  font-weight: 700;
  font-size: clamp(20px, 1.7vw, 30px);
  letter-spacing: 0.2px;
}

.assignment {
  font-family: var(--token-font-body);
  font-size: clamp(20px, 1.7vw, 30px);
  line-height: 1.4;
  /* Highlighter feel from the example slide, built from the theme accent. */
  background: color-mix(in srgb, var(--token-accent) 26%, transparent);
  border-radius: 6px;
  padding: 2px 8px;
}

.assignmentEmpty {
  font-family: var(--token-font-body);
  font-size: clamp(20px, 1.7vw, 30px);
  color: rgba(28, 38, 32, 0.4);
}

.empty {
  margin: 0;
  font-family: var(--token-font-body);
  font-size: clamp(20px, 1.7vw, 28px);
  color: rgba(28, 38, 32, 0.55);
}
